import "./EditarBundle.scss";

import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import Menu from "../../components/Menu/Menu";
import { MenuProps } from "../../components/Menu/MenuTypes";
import { defaultMenuProps } from "../../constants/constants";
import BundleData from "../../components/Bundle/BundleData/BundleData";
import { getApiBundle } from "../../services/apiBundle";
import { BundleDataProps } from "../../components/Bundle/BundleData/BundleDataTypes";

const EditarBundle = (): React.ReactElement =>{
  const urlParams = useParams();
  const [menuProps, setMenuProps] = useState<MenuProps>(defaultMenuProps);
  const [bundleData, setBundleData] = useState<BundleDataProps>({bundle:{ _id: '' }});
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    getBundle({ _id: urlParams.bundleId})
  }, []);

  const getBundle = async (attributes: any): Promise<void> => {
    getApiBundle(
      {
        _id: attributes._id
      }
    ).then(async (response: any) => {
      // Separate the picture_landing URL into picture_landing_url to avoid createObjectURL errors
      const bundleWithSeparatedPictureLanding = {
        ...response.bundle,
        picture_landing_url: response.bundle.picture_landing,
        picture_landing: null
      };
      setBundleData({
        bundle: bundleWithSeparatedPictureLanding
      })

      setLoaded(true)
    })
    .catch((error: any) => {
      console.log(error.message);
    });
  }

  return(
    <React.Fragment>
      <div id="menu">
        <Menu items={ menuProps.items } />
      </div>

      <div id="app-content">
        <header className="table-header mb-4">
          <h1>Editar bundle</h1>
          <span></span>
        </header>

        { loaded &&
          <BundleData bundle={ bundleData.bundle } />
        }
      </div>
    </React.Fragment>
  )
}

export default EditarBundle;
